enum ConditionalTile {
  FinanceExpiredPrequal = 'financeExpiredPrequal',
  FinanceLowMinDown = 'financeLowMinDown',
  FinanceNoPrequal = 'financeNoPrequal',
  FinanceZeroMinDown = 'financeZeroMinDown',
  FreeShipping = 'freeShipping',
  GreatDeals = 'greatDeals',
  PriceDrop = 'priceDrop',
  SavedSearch = 'savedSearch',
  SebastianTileA = 'sebastianTileA',
  SebastianTileB = 'sebastianTileB',
  TradeNoTrade = 'tradeNoTrade',
  TradeOfferExpired = 'tradeOfferExpired'
}

export default ConditionalTile;
